var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11486_45179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0206 5.95197L14.2617 3.20125C14.1814 3.11714 14.0848 3.05017 13.9777 3.00441C13.8706 2.95865 13.7554 2.93506 13.6389 2.93506C13.5224 2.93506 13.4071 2.95865 13.3 3.00441C13.193 3.05017 13.0964 3.11714 13.016 3.20125L11.3256 4.88675L4.73951 11.4519C4.65084 11.5403 4.65084 11.6287 4.56218 11.7186V11.807L3.13769 15.9765C3.09323 16.1272 3.08614 16.2863 3.11703 16.4403C3.14792 16.5943 3.21586 16.7385 3.31502 16.8605C3.39336 16.9474 3.48971 17.0162 3.59738 17.0623C3.70506 17.1083 3.82148 17.1305 3.9386 17.1272C3.98697 17.1333 4.0361 17.1285 4.08238 17.1132C4.12867 17.0979 4.17093 17.0725 4.20606 17.0388L8.38791 15.6185H8.47657C8.56524 15.6185 8.6539 15.5301 8.74404 15.4417L17.0191 7.19104C17.1031 7.11109 17.17 7.01501 17.2157 6.90858C17.2615 6.80216 17.2851 6.6876 17.2853 6.57182C17.2854 6.45603 17.262 6.34142 17.2165 6.23489C17.171 6.12836 17.1044 6.03211 17.0206 5.95197ZM15.1513 6.57371L14.708 7.01571L13.1934 5.50702L13.6367 5.06502L15.1513 6.57371ZM8.12193 13.5824L7.40969 12.8722L6.60878 12.0692L11.9477 6.75051L13.4608 8.25773L8.12193 13.5824ZM5.36309 14.8244L5.71921 13.7592L6.43146 14.4693L5.36309 14.8244Z",
    fill: "#262758",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11486_45179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.72412 2.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd3e16aca18be8a2110afe26314f04f6.svg";
export { ForwardRef as ReactComponent };